@use "src/components/docs/inlineReference";

.link[data-api-reference],
.link[data-error-reference] {
  display: inline;
  font-size: 0.9em;
  line-height: inherit;
  color: var(--color-inline-code-foreground);
  text-decoration: none;
  overflow-wrap: normal;
  word-break: normal;

  .chip {
    @include inlineReference.reference;
    min-height: 0;
    border-color: color-mix(in srgb, currentColor 20%, transparent);
    padding: 0.1em 0.3em;
    font-size: 0.85em;
    font-weight: 600;
    line-height: 1;
    vertical-align: baseline;
    font-family: var(--font-mono, monospace);
  }

  .text {
    font-family: var(--font-mono, monospace);
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  &:hover .text {
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
    border-radius: 0.375rem;
  }
}
